module.exports = __webpack_public_path__ + "static/media/play-board-intro-4.ae162b9a.png";